module.exports = __webpack_public_path__ + "img/bg_function06_3_m.131e91e7.svg";